export default __webpack_public_path__ + "static/media/198property-gallery3.9a671616.webp";